import axios, { AxiosInstance } from "axios";
import { AuthUser } from "../../models/AuthUser";
import AuthStorage  from "../../storages/AuthStorage";
import { login }    from "../PrincipalAuthService";

/* Create basic AxiosInstance with common properties such as 
 * BaseUrl and ContentType format */
const anonymousRestClient: AxiosInstance = axios.create({
    baseURL: process.env.REACT_APP_REST_BASEURL,
    headers: {
        "Content-Type": "application/json"
    }
});

/* Adds a interceptor for each request made with 
 * previous created axiosInstance
 */ 
anonymousRestClient.interceptors.request.use(
    async (config) => {
        const user: AuthUser | null = AuthStorage.getCurrentUser();
        if (user != null)
        {
            /* Adds the currently valid JWT to the request header.*/
            config.headers["Authorization"] = 'Bearer ' + user.token;
        }
        return config;
    },
    (error) => {
        return Promise.reject(error); /* Pass on error */
    }
);

anonymousRestClient.interceptors.response.use(
    (response) => {
        return response;
    },
    async (error) => {
        const receivedConfig = error.config;
        if (error.response.status === 401 && !receivedConfig._retry) {
            receivedConfig._retry = true;
            try
            {
                const authUser = await login("mschmidt@era.int", "Qst3hh3GGDJ7XJ");
                receivedConfig.headers["Authorization"] = 'Bearer ' + authUser?.token;

                return axios(receivedConfig);
            }
            catch
            {
                // Handle errors when refreshing token ...
            }
        }
        return Promise.reject(error);
    }

)
export default anonymousRestClient;